import { GuardedType, isString } from "generic-type-guard";

import { createDescriptorFunctions } from "@de.skhh.modulf/client-core";

export const OpenregisterSelectRecordModalDescriptor = createDescriptorFunctions(
	{
		modal: "OpenregisterSelectRecordModal"
	} as const,
	{
		openregisterPath: isString,
		mappingConfigurationId: isString,
		sourceActivityId: isString
	}
);

export type OpenregisterSelectRecordModalDescriptor = GuardedType<
	typeof OpenregisterSelectRecordModalDescriptor.isInstance
>;
